import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["style", "className", "children", "size", "isSelected", "isLoading", "isDisabled", "as", "type", "onClick", "IconLeft", "IconRight", "Loading"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { useCallback, forwardRef, useState } from 'react';
import { useStyles, StyleSheet, useToken, text, icon, border, padding } from '@rexlabs/styling';
import LoadingSpinner from '@rexlabs/loading-spinner';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread(_objectSpread({
    display: 'inline-flex',
    flexShrink: 0,
    userSelect: 'none',
    cursor: 'pointer',
    transition: 'background .2s, color .2s, border .2s'
  }, text.styles({
    target: 'button',
    fallback: 'normal.semibold',
    color: function color(_ref) {
      var token = _ref.token;
      return token('color.textStyle.body.default');
    },
    textDecoration: function textDecoration() {
      return 'none';
    }
  })), border.styles({
    target: 'button',
    all: {
      width: 'thin',
      radius: 'm'
    }
  })), {}, {
    width: function width(_ref2) {
      var token = _ref2.token;
      return token('button.width', 'auto');
    },
    backgroundColor: function backgroundColor(_ref3) {
      var token = _ref3.token;
      return token('button.background.color');
    },
    textDecorationColor: function textDecorationColor(_ref4) {
      var token = _ref4.token;
      return token('button.textDecorationColor');
    },
    boxShadow: function boxShadow(_ref5) {
      var token = _ref5.token;
      return token('button.boxShadow', token('shadow.medium'));
    },
    '&:hover:enabled': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.hover'
    })), border.styles({
      target: 'button.hover'
    })), {}, {
      backgroundColor: function backgroundColor(_ref6) {
        var token = _ref6.token;
        return token('button.hover.background.color');
      },
      textDecorationColor: function textDecorationColor(_ref7) {
        var token = _ref7.token;
        return token('button.hover.textDecorationColor');
      }
    }),
    '&:focus:enabled': {
      boxShadow: function boxShadow(_ref8) {
        var token = _ref8.token;
        return token('shadow.focus');
      }
    },
    '&:active:enabled': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.active',
      textDecoration: function textDecoration() {
        return 'none';
      }
    })), border.styles({
      target: 'button.active'
    })), {}, {
      backgroundColor: function backgroundColor(_ref9) {
        var token = _ref9.token;
        return token('button.active.background.color');
      },
      textDecorationColor: function textDecorationColor(_ref10) {
        var token = _ref10.token;
        return token('button.active.textDecorationColor');
      }
    })
  }),
  container2ExtraSmall: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: ['button', 'button.2xs'],
    fallback: 'tiny.semibold'
  })), padding.styles({
    target: ['button', 'button.2xs'],
    x: 'xxxs',
    y: 'none'
  })), {}, {
    height: function height(_ref11) {
      var token = _ref11.token;
      return token('button.2xs.height', token('button.height', '1.6rem'));
    },
    minWidth: function minWidth(_ref12) {
      var token = _ref12.token;
      return token('button.2xs.minWidth', token('button.minWidth', '2rem'));
    }
  }),
  containerExtraSmall: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: ['button', 'button.xs'],
    fallback: 'tiny.semibold'
  })), padding.styles({
    target: ['button', 'button.xs'],
    x: 'xxxs',
    y: 'none'
  })), {}, {
    height: function height(_ref13) {
      var token = _ref13.token;
      return token('button.xs.height', token('button.height', '2rem'));
    },
    minWidth: function minWidth(_ref14) {
      var token = _ref14.token;
      return token('button.xs.minWidth', token('button.minWidth', '2.6rem'));
    }
  }),
  containerSmall: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: ['button', 'button.s'],
    fallback: 'small.semibold'
  })), padding.styles({
    target: ['button', 'button.s'],
    x: 's',
    y: 'none'
  })), {}, {
    height: function height(_ref15) {
      var token = _ref15.token;
      return token('button.s.height', token('button.height', '3.2rem'));
    },
    minWidth: function minWidth(_ref16) {
      var token = _ref16.token;
      return token('button.s.minWidth', token('button.minWidth', '4.2rem'));
    }
  }),
  containerMedium: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: ['button', 'button.m'],
    fallback: 'normal.semibold'
  })), padding.styles({
    target: ['button', 'button.m'],
    x: 'm',
    y: 'none'
  })), {}, {
    height: function height(_ref17) {
      var token = _ref17.token;
      return token('button.m.height', token('button.height', '4rem'));
    },
    minWidth: function minWidth(_ref18) {
      var token = _ref18.token;
      return token('button.m.minWidth', token('button.minWidth', '5.2rem'));
    }
  }),
  containerSelected: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: 'button.selected',
    textDecoration: function textDecoration() {
      return 'none';
    }
  })), border.styles({
    target: 'button.selected'
  })), {}, {
    backgroundColor: function backgroundColor(_ref19) {
      var token = _ref19.token;
      return token('button.selected.background.color');
    },
    '&:hover:enabled': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.selected.hover',
      textDecoration: function textDecoration() {
        return 'none';
      }
    })), border.styles({
      target: 'button.selected.hover'
    })), {}, {
      backgroundColor: function backgroundColor(_ref20) {
        var token = _ref20.token;
        return token('button.selected.hover.background.color');
      }
    })
  }),
  containerLoading: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: 'button.loading',
    textDecoration: function textDecoration() {
      return 'none';
    }
  })), border.styles({
    target: 'button.loading'
  })), {}, {
    cursor: function cursor(_ref21) {
      var token = _ref21.token;
      return token('button.loading.cursor', 'default');
    },
    backgroundColor: function backgroundColor(_ref22) {
      var token = _ref22.token;
      return token('button.loading.background.color');
    },
    '&:hover:enabled': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.loading.hover',
      textDecoration: function textDecoration() {
        return 'none';
      }
    })), border.styles({
      target: 'button.loading.hover'
    })), {}, {
      backgroundColor: function backgroundColor(_ref23) {
        var token = _ref23.token;
        return token('button.loading.hover.background.color');
      }
    }),
    '&:active:enabled': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.loading.active'
    })), border.styles({
      target: 'button.loading.active'
    })), {}, {
      backgroundColor: function backgroundColor(_ref24) {
        var token = _ref24.token;
        return token('button.loading.active.background.color');
      }
    })
  }),
  containerDisabled: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: 'button.disabled',
    textDecoration: function textDecoration() {
      return 'none';
    }
  })), border.styles({
    target: 'button.disabled'
  })), {}, {
    backgroundColor: function backgroundColor(_ref25) {
      var token = _ref25.token;
      return token('button.disabled.background.color');
    },
    cursor: function cursor(_ref26) {
      var token = _ref26.token;
      return token('button.disabled.cursor', 'default');
    },
    opacity: function opacity(_ref27) {
      var token = _ref27.token;
      return token('button.disabled.opacity', 0.5);
    },
    '&:hover': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.disabled.hover',
      textDecoration: function textDecoration() {
        return 'none';
      }
    })), border.styles({
      target: 'button.disabled.hover'
    })), {}, {
      backgroundColor: function backgroundColor(_ref28) {
        var token = _ref28.token;
        return token('button.disabled.hover.background.color');
      },
      textDecorationColor: function textDecorationColor(_ref29) {
        var token = _ref29.token;
        return token('button.disabled.hover.textDecorationColor');
      }
    }),
    '&:active': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'button.disabled.active'
    })), border.styles({
      target: 'button.disabled.active'
    })), {}, {
      backgroundColor: function backgroundColor(_ref30) {
        var token = _ref30.token;
        return token('button.disabled.active.background.color');
      },
      textDecorationColor: function textDecorationColor(_ref31) {
        var token = _ref31.token;
        return token('button.disabled.active.textDecorationColor');
      }
    })
  }),
  // This wrapper is used as the relatively positioned
  // element that contains the loading container
  // so that outside styles can be applied to the button
  // without the button styles interfering (e.g. for adding
  // a psuedo element to the button to increase hit area)
  wrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    whiteSpace: 'nowrap'
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  contentLoading: {
    opacity: 0
  },
  wrapLoading: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    display: 'flex'
  },
  icon2ExtraSmall: {
    '& > svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.2xs'],
      size: 's'
    }))
  },
  iconExtraSmall: {
    '& > svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.xs'],
      size: 'm'
    }))
  },
  iconSmall: {
    '& > svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.s'],
      size: 's'
    }))
  },
  iconMedium: {
    '& > svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.m'],
      size: 'm'
    }))
  },
  iconLeft: _objectSpread({}, padding.styles({
    target: 'button.icon.left',
    right: 'xs'
  })),
  iconRight: _objectSpread({}, padding.styles({
    target: 'button.icon.right',
    left: 'xs'
  })),
  iconLoading: {
    opacity: 0
  },
  // Need to target all descendants
  // because the loading spinner is
  // wrapped in another element
  loadingIcon2ExtraSmall: {
    '& svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.2xs'],
      size: 's'
    }))
  },
  loadingIconExtraSmall: {
    '& svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.xs'],
      size: 'm'
    }))
  },
  loadingIconSmall: {
    '& svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.s'],
      size: 's'
    }))
  },
  loadingIconMedium: {
    '& svg': _objectSpread({}, icon.styles({
      target: ['button', 'button.m'],
      size: 'm'
    }))
  }
});

function DefaultLoadingSpinner() {
  var token = useToken();
  return /*#__PURE__*/React.createElement(LoadingSpinner, {
    colors: [token('button.color', token('color.textStyle.body.default'))]
  });
}

var displayName = 'Button';
var defaultIconSizes = {
  '2xs': 's',
  xs: 'm',
  s: 's',
  m: 'm'
};
/**
 * Buttons allow users to perform an action or to navigate to another page. They have multiple styles for various needs, and are ideal for calling attention to where a user needs to do something in order to move forward in a flow.
 */

export var Button = /*#__PURE__*/forwardRef(function (_ref32, ref) {
  var style = _ref32.style,
      className = _ref32.className,
      children = _ref32.children,
      _ref32$size = _ref32.size,
      size = _ref32$size === void 0 ? 'm' : _ref32$size,
      _ref32$isSelected = _ref32.isSelected,
      isSelected = _ref32$isSelected === void 0 ? false : _ref32$isSelected,
      isLoadingProp = _ref32.isLoading,
      _ref32$isDisabled = _ref32.isDisabled,
      isDisabled = _ref32$isDisabled === void 0 ? false : _ref32$isDisabled,
      _ref32$as = _ref32.as,
      Container = _ref32$as === void 0 ? 'button' : _ref32$as,
      _ref32$type = _ref32.type,
      type = _ref32$type === void 0 ? Container === 'button' ? 'button' : undefined : _ref32$type,
      onClick = _ref32.onClick,
      IconLeft = _ref32.IconLeft,
      IconRight = _ref32.IconRight,
      LoadingProp = _ref32.Loading,
      rest = _objectWithoutProperties(_ref32, _excluded);

  var s = useStyles(defaultStyles, displayName);
  var token = useToken(); // If the loading state is not controlled via the isLoading prop,
  // we want to controll it locally when the `onClick` returns a Promise

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      localIsLoading = _useState2[0],
      setLocalIsLoading = _useState2[1];

  var isLoading = isLoadingProp || localIsLoading;
  var disabled = isDisabled || isLoading;
  var Loading = LoadingProp || token('button.loadingSpinner', DefaultLoadingSpinner); // If we use the `as` prop to change the html tag
  // then the `disabled` attribute isn't respected
  // like it is when the tag is `button`

  var handleClick = useCallback(function (e) {
    if (!disabled) {
      var result = onClick === null || onClick === void 0 ? void 0 : onClick(e);

      if (isLoadingProp === undefined && result && result !== null && result !== void 0 && result.then) {
        setLocalIsLoading(true);
        result.then(function () {
          setLocalIsLoading(false);
        }).catch(function (error) {
          console.error(error);
          setLocalIsLoading(false);
        });
      }
    }
  }, [disabled, onClick, isLoadingProp]);
  var iconSize = token('button.svg.size', defaultIconSizes[size]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, rest, s.with('container', {
    container2ExtraSmall: size === '2xs',
    containerExtraSmall: size === 'xs',
    containerSmall: size === 's',
    containerMedium: size === 'm',
    containerSelected: isSelected,
    containerLoading: isLoading,
    containerDisabled: isDisabled
  })({
    style: style,
    className: className
  }), {
    ref: ref,
    type: type,
    disabled: disabled,
    onClick: handleClick
  }), /*#__PURE__*/React.createElement("div", s('wrapper'), IconLeft && /*#__PURE__*/React.createElement("span", s('icon', 'iconLeft', {
    icon2ExtraSmall: size === '2xs',
    iconExtraSmall: size === 'xs',
    iconSmall: size === 's',
    iconMedium: size === 'm',
    iconLoading: isLoading
  }), /*#__PURE__*/React.createElement(IconLeft, {
    size: iconSize
  })), /*#__PURE__*/React.createElement("span", s('icon', 'content', {
    icon2ExtraSmall: size === '2xs',
    iconExtraSmall: size === 'xs',
    iconSmall: size === 's',
    iconMedium: size === 'm',
    contentLoading: isLoading
  }), children), IconRight && /*#__PURE__*/React.createElement("span", s('icon', 'iconRight', {
    icon2ExtraSmall: size === '2xs',
    iconExtraSmall: size === 'xs',
    iconSmall: size === 's',
    iconMedium: size === 'm',
    iconLoading: isLoading
  }), /*#__PURE__*/React.createElement(IconRight, {
    size: iconSize
  })), isLoading && /*#__PURE__*/React.createElement("span", s('icon', 'wrapLoading', {
    loadingIcon2ExtraSmall: size === '2xs',
    loadingIconExtraSmall: size === 'xs',
    loadingIconSmall: size === 's',
    loadingIconMedium: size === 'm'
  }), /*#__PURE__*/React.createElement(Loading, null))));
});
Button.displayName = displayName;
export default Button;